import FaIcon from '@app/lui3/FaIcon';
import {useMemo} from 'react';

import Avatar from '../../../Avatar';
import {OutlookPersonFromEmailJson} from '../../../requests';
import {emailMatchesSet, normalizeEmailVariants} from './emailNormalization';
import {
  RecipientBtn,
  RecipientEmail,
  RecipientName,
  RecipientRowContainer,
  RecipientRowLeft,
  RecipientTextBlock,
} from './styles';

interface Props {
  person: OutlookPersonFromEmailJson;
  syncableEmailAddresses: string[];
}

const LoxoRecipient = ({person, syncableEmailAddresses}: Props) => {
  const syncableEmailSet = useMemo(() => {
    return new Set(syncableEmailAddresses.flatMap(normalizeEmailVariants));
  }, [syncableEmailAddresses]);

  const email = useMemo(() => {
    return person.emails.find((e) => emailMatchesSet(e.value, syncableEmailSet))
      ?.value;
  }, [person.emails, syncableEmailSet]);

  const displayEmail = email ?? person.emails[0]?.value;

  return (
    <RecipientRowContainer>
      <RecipientRowLeft>
        <Avatar
          name={person.name ?? ''}
          imageUrl={person.profile_picture_thumb_url}
          size="md"
        />
        <RecipientTextBlock>
          <RecipientName>{person.name}</RecipientName>
          <RecipientEmail>{displayEmail}</RecipientEmail>
        </RecipientTextBlock>
      </RecipientRowLeft>
      <RecipientBtn
        size="medium"
        after={<FaIcon icon="arrow-up-right" size="sm" />}
        onClick={() => {
          window.open(person.loxo_url ?? '', '_blank');
        }}
      >
        View
      </RecipientBtn>
    </RecipientRowContainer>
  );
};

export default LoxoRecipient;
